import get from "lodash/get";
import set from "lodash/set";

import { asyncIsValidPhoneNumber } from "components/ui/source/util/phone";
import {
  isValidEmail,
  isValidPassword,
} from "components/ui/source/util/validators";

const REQUIRED_SIGN_UP_FIELDS = [
  "email",
  "emailConfirmation",
  "password",
  "firstName",
  "lastName",
];

const REQUIRED_REFERRAL_SIGN_UP_FIELDS = ["countryCode", "phoneNumber"];

export function validateLoginForm(values) {
  const errors = {};

  // Don't show any error messages, just deactivate a cta button
  // https://app.asana.com/0/1156836590186794/1190226023256394
  const email = get(values, "email");
  if (!email || !isValidEmail(email)) {
    set(errors, "email", "");
  }

  // Don't show any error messages, just deactivate a cta button
  const password = get(values, "password");
  if (!password) {
    set(errors, "password", "");
  }

  return errors;
}

export function validateSignUpForm(values, t) {
  const prefix = "modals.accounts.errors";
  const errors = {};

  // Check required fields
  REQUIRED_SIGN_UP_FIELDS.forEach(key => {
    if (!get(values, key)) {
      set(errors, key, t(`${prefix}.required`));
    }
  });

  // Email
  const email = get(values, "email");
  const confirmEmail = get(values, "emailConfirmation");
  if (!email || !isValidEmail(email)) {
    set(errors, "email", t(`${prefix}.invalidEmail`));
  }
  // Email / confirm email should be same
  if (email && email !== confirmEmail) {
    set(errors, "emailConfirmation", t(`${prefix}.emailMismatch`));
  }

  // Password
  const password = get(values, "password");
  if (!password || !isValidPassword(password)) {
    set(errors, "password", t(`${prefix}.invalidPassword`));
  }

  // First name
  if (!get(values, "firstName")) {
    set(errors, "firstName", t(`${prefix}.invalidFirstName`));
  }

  // Last name
  if (!get(values, "lastName")) {
    set(errors, "lastName", t(`${prefix}.invalidLastName`));
  }

  return errors;
}

export async function validateReferralForm(values, t) {
  const prefix = "modals.accounts.errors";
  const errors = {};

  // Check required fields
  REQUIRED_REFERRAL_SIGN_UP_FIELDS.forEach(key => {
    if (!get(values, key)) {
      set(errors, key, t(`${prefix}.required`));
    }
  });

  const countryCode = get(values, "countryCode");
  const phoneNumber = get(values, "phoneNumber");
  if (
    !countryCode ||
    !phoneNumber ||
    !(await asyncIsValidPhoneNumber(countryCode, phoneNumber))
  ) {
    set(errors, "phoneNumber", t(`${prefix}.invalidPhone`));
  }

  return errors;
}

export function validateResetPasswordForm(values, t) {
  const prefix = "modals.accounts.errors";
  const errors = {};

  const email = get(values, "email");
  if (!email || !isValidEmail(email)) {
    set(errors, "email", t(`${prefix}.invalidEmail`));
  }

  return errors;
}

export function validateEmailSelectorForm(values, t) {
  const prefix = "modals.accounts.errors";
  const errors = {};

  const email = get(values, "email");
  if (!email) {
    set(errors, "email", ""); // Don't need to show 'required info' in selector form
  } else if (!isValidEmail(email)) {
    set(errors, "email", t(`${prefix}.invalidEmail`));
  }

  return errors;
}

export function validatePhoneVerficationCode(values) {
  const errors = {};

  // Check if the code is a 4 digit number
  const verificationCode = get(values, "verificationCode");
  if (!verificationCode || !/^\d{4}$/.test(verificationCode)) {
    set(errors, "verificationCode", "");
  }

  return errors;
}
